export enum ItemType {
  BUTTON = 'button',
  DROPDOWN = 'dropdown',
  LINK = 'link',
}
